/*=========================================================================================
  File Name: module-inoicefiles-mutations.js
  Description: InvoiceFiles Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

export default {};
